import { createApp, markRaw } from 'vue';
import { createPinia }        from 'pinia';
import * as Sentry            from '@sentry/vue';

import App from './App.vue';
import './styles/transition.scss';
import '@pixul/aglaea/dist/style.css';

import { Aglaea, i18n as AI18n, Formatter } from '@pixul/aglaea';
import HestiaApi                            from '@/api';
import { mergeDeep }                        from '@/utils/mergeDeep';
import i18n                                 from './lang';
import { Hephaestus, i18n as HI18n }        from '@pixul/hephaestus/global';
import Posthog                              from '@/plugins/Posthog';
import Config                               from '@/config';
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor';

mergeDeep(i18n.global.messages, AI18n.global.messages);
mergeDeep(i18n.global.messages, HI18n.global.messages);

const app = createApp(App);
const pinia = createPinia();

Sentry.init({
  app,
  release          : `comms@${ Config.version }`,
  dsn              : Config.sentryDsn,
  environment      : Config.environment,
  sendDefaultPii   : true,
  normalizeDepth   : 10,
  integrations     : [
    Sentry.browserTracingIntegration({ router })
  ],
  tracingOptions   : {
    trackComponents : true
  },
  tracesSampleRate : 0.1
});

pinia.use(Sentry.createSentryPiniaPlugin());

if (Config.environment !== 'development') {
  app.use(Posthog, { token : Config.postHogToken, apiHost : Config.postHogApiHost });
} else {

  window.$hestia = HestiaApi;

  //On mock posthog en dev pour avoir accès a tout et ne pas avoir d'erreurs
  app.config.globalProperties.$posthog = {
    callback            : undefined,
    //['proformas','administration','documents_tab','commission_tab','partners_tab']
    forcedDisabledFlags : [],
    isFeatureEnabled(featureFlag) {

      return !this.forcedDisabledFlags.includes(featureFlag);
    },

    capture() {
    },

    identify() {

      if (this.callback) {
        this.callback();
      }
    },

    onFeatureFlags(callback) {

      this.callback = callback;
    }
  };
}

import router from './router';

import * as Countries from 'i18n-iso-countries';

pinia.use(({ store }) => {

  store.$router = markRaw(router);
});
app.use(pinia);

app.provide('$posthog', app.config.globalProperties.$posthog);

app.use(router);
app.use(i18n);
app.use(Aglaea);
app.use(Hephaestus);

app.use(VueMonacoEditorPlugin, {
  paths : {
    // The recommended CDN config
    vs : 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs'
  }
});
app.config.globalProperties.$hestia = HestiaApi;

const formatter = new Formatter(i18n);
app.use(formatter);

import frLocale from 'i18n-iso-countries/langs/fr.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

Countries.registerLocale(frLocale);
Countries.registerLocale(enLocale);

app.mount('#app');
